import { AppEntitlementValue } from 'lib/actions/apps/app-entitlement'
import { expandValue, expandValueList } from 'lib/rpcts'
import { AccessReviewSelection, AccessReviewSelectionView } from 'pbts/c1/api/accessreview/v1/accessreview'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppEntitlement } from 'pbts/c1/api/app/v1/app_entitlement'
import { AppUser } from 'pbts/c1/api/app/v1/app_user'
import { Policy } from 'pbts/c1/api/policy/v1/policy'
import { Task } from 'pbts/c1/api/task/v1/task'
import { User } from 'pbts/c1/api/user/v1/user'
import { Any } from 'pbts/google/protobuf/any'
import { Code as pbCode } from 'pbts/google/rpc/code'
import { Status as pbStatus } from 'pbts/google/rpc/status'

export interface AccessReviewSelectionValue extends AccessReviewSelection {
    user?: User
    appUser?: AppUser
    entitlements?: AppEntitlementValue[]
    certTask?: Task
    app?: App
    policy?: Policy
}

export const expandAccessReviewSelectionView = (
    msg: AccessReviewSelectionView,
    values: Any[],
): AccessReviewSelectionValue => {
    let app = expandValue<App>(msg?.appPath || '', App, values)
    if (app === undefined) {
        const appErr = expandValue<pbStatus>(msg?.appPath || '', pbStatus, values)
        if (appErr?.code === pbCode.NOT_FOUND) {
            app = App.create({
                displayName: 'Deleted App',
            })
        }
    }

    if (app?.deletedAt) {
        app.displayName += ' [Deleted]'
    }
    return {
        ...AccessReviewSelection.create(msg.accessReviewSelection ?? {}),
        user: expandValue<User>(msg.userPath, User, values),
        appUser: expandValue<AppUser>(msg.appUserPath, AppUser, values),
        entitlements: expandValueList<AppEntitlement>(msg.entitlementsPath, AppEntitlement, values),
        certTask: expandValue<Task>(msg.certTaskPath, Task, values),
        app,
        policy: expandValue<Policy>(msg?.policyPath || '', Policy, values),
    }
}
